import axios from "../plugins/parseAxios";

export class DigitalMeterApi {
  static turnOnDigitalMeter(meterId,note) {
    return axios.post("functions/turnOnDigitalMeter", {
      meterId,
      note
    });
  }
  static turnOffDigitalMeter(meterId,note) {
    return axios.post("functions/turnOffDigitalMeter", { 
      meterId,
      note
     });
  }
  static addBalanceDigitalMeter(meterId, amount) {
    return axios.post("functions/addBalanceDigitalMeter", { meterId, amount });
  }
  static resetBalanceDigitalMeter(meterId, amount, note) {
    return axios.post("functions/resetBalanceDigitalMeter", { meterId, amount, note });
  }
}